import { Button, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Skeleton, Tooltip, Typography } from "@mui/material";
import { Dialog as KendoDialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import DeleteIcon from '@mui/icons-material/Delete';

import { useSaveData } from "../../../../hooks/useSaveData";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import FormInput from "../../../../components/hook-form/form-input.component";
import { planReviewApiKeyStore } from "../../../../api/plan-review-api-key-store";
import { LoadingIndicator } from "../../../../components/loading-indicator.component";
import { GuardedComponent } from "../../../../components/guarded-component";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { Icons } from "../../../../assets/icons";
import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useFileDownload } from "../../../../components/file-download";
import { ApiErrorComponent } from "../../../../components/api-error.component";
import { useDeleteData } from "../../../../hooks/useDeleteData";
import { unitsApiKeyStore } from "../../../../api/units-api-key-store";

const styling = {
    dropZone: {
        padding: '10px 5px 10px',
        border: '0.1em dashed #99A3A4',
        backgroundColor: '#F2F3F4',
        // display: 'none',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: '4px',
        marginRight: '0px',
    },
}

interface PlanReviewTaskDialog {
    planReviewData: any;
    moduleCode: string;
    isParentLoading: boolean;
    passFileData: (fileData: any) => void;
    passStatusValue: (status: string) => void;
}

export const PlanReviewTaskSelectResult = ({ planReviewData, moduleCode, isParentLoading, passFileData, passStatusValue }: PlanReviewTaskDialog) => {

    const { data, isLoading, isFetching, refetch } = useLoadData<ApiResponse<any>>(
        planReviewApiKeyStore.getPlanReviewStatus(moduleCode, planReviewData?.planReviewTaskID)
    );

    const { isLoading: isTaskStatusLoading, mutateAsync } = useSaveData<any>(planReviewApiKeyStore.updatePlanReviewTaskStatus(),
        () => planReviewApiKeyStore.getPlanReviewTask(planReviewData?.planReviewTaskID));

    const handleStatusClick = async (item: any) => {
        const updateStatus = {
            planReviewTaskID: planReviewData?.planReviewTaskID,
            planReviewTaskStatusCode: item?.planReviewTaskStatusCode
        }
        await mutateAsync({ data: updateStatus });
        refetch();
    };

    const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        passStatusValue((event.target as HTMLInputElement).value);
    };

    return (
        <Grid container spacing={2}>
            <Grid item lg={3} sm={3} xl={3} xs={3}>
                <LoadingIndicator isLoading={isParentLoading} />
                <FormInput
                    name="currentStatus"
                    label="Current Status"
                    disabled
                />
            </Grid>
            <Grid item lg={9} sm={9} xl={9} xs={9}>
                <Grid
                    container
                    direction="row"
                    sx={{
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                    }}
                >

                    {(isLoading || isFetching || isTaskStatusLoading) ? (
                        <Skeleton variant="rectangular" width={210} height={40} />
                    ) :

                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={handleStatusChange}
                            >
                                {data?.data?.map((item: any) => (
                                    <div key={item?.planReviewTaskStatusID}>
                                        <FormControlLabel
                                            control={<Radio />}
                                            value={item?.planReviewTaskStatusCode}
                                            label={item?.planReviewTaskStatusName == "Complete" ? "Complete and Send Mail" : item?.planReviewTaskStatusName} />
                                    </div>
                                ))}
                            </RadioGroup>
                        </FormControl>
                        // (
                        //     data?.data?.map((item: any) => (
                        //         <div key={item.planReviewTaskStatusID} style={{ paddingRight: 5 }}>
                        //             <Button style={{ width: item.planReviewTaskStatusName?.length < 10 ? '130px' : '210px' }} type='submit' variant="contained" onClick={() => handleStatusClick(item)}>
                        //                 {item.planReviewTaskStatusName}
                        //             </Button>
                        //         </div>
                        //     ))
                        // )
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}